<template>
    <div class="uebungen-intro">
        <div class="uebungen-intro__container">
            <div class="uebungen-intro__header">
                <hermeneus-icon 
                    name="hib-uebung-activitas" 
                    height="72" 
                    width="72" 
                    color="hi-color-primary-600" 
                    class="uebungen-intro__icon">
                </hermeneus-icon>
                <h1 class="uebungen-intro__title">
                    <span class="uebungen-intro__title-text">Activitas</span>
                </h1>
            </div>
            <div class="uebungen-intro__description">
                Dieses Vokabelspiel lehnt sich an das bekannte Kartenspiel
                <i>Activity</i> an und kann in zwei Teams gespielt werden.
                Ziel des Spiels ist es, dass ein Team durch Erklärung bzw. Darstellung die lateinische Vokabel auf einem
                Kärtchen errät.
                Der Spieler kann die Vokabel darstellen durch ...
                <ul class="uebungen-intro__list">
                    <li class="uebungen-intro__list-item">
                        <i class="hi hi-lips uebungen-intro__list-icon" aria-hidden="true"></i>
                        <span class="uebungen-intro__list-text">... mündliches Erklären.</span>
                    </li>
                    <li class="uebungen-intro__list-item">
                        <i class="fa fa-american-sign-language-interpreting uebungen-intro__list-icon" aria-hidden="true"></i>
                        <span class="uebungen-intro__list-text">... pantomimisches Darstellen.</span>
                    </li>
                    <li class="uebungen-intro__list-item">
                        <i class="hi hi-board-draw uebungen-intro__list-icon"></i>
                        <span class="uebungen-intro__list-text">... Zeichnen der Vokabelbedeutung an der Tafel.</span>
                    </li>
                    <li class="uebungen-intro__list-item">
                        <i class="fa fa-question-circle uebungen-intro__list-icon" aria-hidden="true"></i>
                        <span class="uebungen-intro__list-text">... eine selbstgewählte Aktivität (= Joker).</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "uebung-activitas-introduction",
}
</script>